import { render, staticRenderFns } from "./failOrderTip.vue?vue&type=template&id=2ad183a8&scoped=true"
import script from "./failOrderTip.vue?vue&type=script&lang=js"
export * from "./failOrderTip.vue?vue&type=script&lang=js"
import style0 from "./failOrderTip.vue?vue&type=style&index=0&id=2ad183a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad183a8",
  null
  
)

export default component.exports